import { render } from "./Results.vue?vue&type=template&id=67f18eb7"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"
script.render = render

export default script